import { PreviewEntityTypes } from "@enums/preview-entity-types";
import { WorkflowDetailsValidationErrors } from "@idw-types/common/validation/workflow-details-validation-errors/workflow-details-validation-errors";
import { AXNUIContent, AXNUILayout, AXNUITheme, DCUIContent, DCUITheme } from "@iddataweb/idw-common-ui/types";
import { DCUIThemingStep } from "@idw-types/common/dcui/dcui-theming-step";
import { FormattedWorkflowDetailsConfiguration } from "@idw-types/data/workflow-details-configuration";
import { getWorkflowGeneralValidationErrors } from "./workflow-general-validation-util";
import { getThemingValidationErrors } from "../common/theming/theming-validation-util";
import { getDCUIThemingValidationErrors } from "../common/dcui-theming/dcui-theming-validation-util";
import { getWorkflowAttributesValidationErrors } from "./workflow-attributes-validation-util";
import { FormattedRpServiceConfiguration, FormattedRpServiceConfigurationAttribute } from "@idw-types/data/rp-service-configuration";
import { LocaleTypes } from "@iddataweb/idw-common-ui/enums";
import { BaseRedirectUrl } from "@idw-types/redirect-url-information";

export const getWorkflowValidationErrors = (
    isUsingThemedUI: boolean,
    hasDisplayableDocumentCaptureAttributes: boolean,
    documentCaptureSteps: Array<DCUIThemingStep>,
    axnuiContent: AXNUIContent,
    axnuiLayout: AXNUILayout,
    axnuiTheme: AXNUITheme,
    dcuiContent: DCUIContent,
    dcuiTheme: DCUITheme,
    workflowDetailsConfiguration: FormattedWorkflowDetailsConfiguration,
    activeAttributes: Array<FormattedRpServiceConfigurationAttribute>,
    isMultiLanguageEnabled: boolean,
    availableLanguages: Array<LocaleTypes>,
    isDisplayResultsEnabled: boolean,
    redirectUrls: Array<BaseRedirectUrl>,
    primaryRpService: FormattedRpServiceConfiguration
): WorkflowDetailsValidationErrors => {

    const generalValidationErrors = getWorkflowGeneralValidationErrors(workflowDetailsConfiguration, isMultiLanguageEnabled, availableLanguages, primaryRpService);
    const themingValidationErrors = getThemingValidationErrors(
        PreviewEntityTypes.WORKFLOW,
        isUsingThemedUI,
        hasDisplayableDocumentCaptureAttributes,
        false,
        false,
        false,
        false,
        null,
        null,
        axnuiContent,
        axnuiLayout,
        axnuiTheme,
        isDisplayResultsEnabled,
        redirectUrls,
        [],
        []
    );
    const dcuiThemingValidationErrors = getDCUIThemingValidationErrors(
        true,
        hasDisplayableDocumentCaptureAttributes,
        documentCaptureSteps,
        {
            hasValidAcuantDPIValidationProperty: true,
            hasValidAcuantGlareValidationProperty: true,
            hasValidAcuantSDKCaptureProperty: true,
            hasValidAcuantSharpnessValidationProperty: true,
            hasValidLivenessApikey: true
        },
        dcuiContent,
        dcuiTheme
    );

    const attributesValidationErrors = getWorkflowAttributesValidationErrors(axnuiContent.labels.attributes, activeAttributes);

    const count = themingValidationErrors.count
        + generalValidationErrors.count
        + dcuiThemingValidationErrors.count
        + attributesValidationErrors.count;

    return {
        general: generalValidationErrors,
        theming: themingValidationErrors,
        dcuiTheming: dcuiThemingValidationErrors,
        attributes: attributesValidationErrors,
        count: count
    };
};